import React from "react";
import { capitalize } from "utils/string";
import { OnboardingState } from "types/onboarding";
import * as Styled from "./styled";

const mapOnboardingStatusToLabel = (status) => {
  switch (status) {
    case OnboardingState.linkedIncomeAccount:
      return "Linked Income";
    case OnboardingState.linkedCoreFinancialInstitutionAccount:
      return "Linked Bank";
    case OnboardingState.submittedIdentityVerification:
      return "IDV Submitted";
    case OnboardingState.acceptedTermsAndConditions:
      return "Accepted Terms";
    case OnboardingState.submittedPersonalInformation:
      return "Personal Info Saved";
    case OnboardingState.verifiedIdentity:
      return "ID Verified";
    case OnboardingState.switchedDirectDeposit:
      return "Switched DD";
    case OnboardingState.issuedCard:
      return "Card Issued";
    default:
      return capitalize(status.replace(/_/g, " "));
  }
};

interface Props {
  status: OnboardingState;
}

const OnboardingStatusTag: React.FC<Props> = ({ status }) => (
  <Styled.Wrapper $status={status}>
    {mapOnboardingStatusToLabel(status)}
  </Styled.Wrapper>
);

export default OnboardingStatusTag;
